import { useContext } from "react";
import { useSelector } from "react-redux";
import { Identifiable, Resource } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  resources: Identifiable<Resource>[];
  canLoadMore: boolean;
  currentPage: number;
  retrieveResourceSubordinates(
    request: Boundaries["retrieveResourceSubordinates"]["request"],
  ): void;
}

function useRetrieveResourceSubordinates(
  resource: Identifiable<Resource>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveResourceSubordinatesRequestPending(resource),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveResourceSubordinatesRequestSuccess(resource),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveResourceSubordinatesRequestFailure(resource),
    ),
    resources: useSelector(() => selector.getResourceSubordinates(resource)),
    canLoadMore: useSelector(() =>
      selector.canLoadMoreResourceSubordinates(resource),
    ),
    currentPage: useSelector(() =>
      selector.getResourceSubordinatesCurrentPage(resource),
    ),
    retrieveResourceSubordinates: core.retrieveResourceSubordinates,
  };
}

export { useRetrieveResourceSubordinates };
